import React, { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useUserDetails } from '../Stores/UserDetails';

/**
 * This components redirect to '/'  if user is logged in
 * @param {Object} props
 */

const AuthRedirect =
  (WrappedComponent: $TSFixMe) =>
  ({ ...props }) => {
    const [isLoggedIn, isBlueprintMode] = useUserDetails(
      // @ts-expect-error TS(2339): Property 'construction_takeoff' does not exist on ... Remove this comment to see the full error message
      useShallow(state => [state.isLoggedIn, state.user?.construction_takeoff])
    );

    useEffect(() => {
      if (isLoggedIn) {
        props.history.push(isBlueprintMode ? '/blueprint' : '/');
      }
    }, []);

    return <WrappedComponent {...props} />;
  };
export default AuthRedirect;
